import { SESSION_STATUS } from './sessionConstants';

const EMPTY_ARRAY = Object.freeze([]);

export const selectSessionStatus = (state) =>
    state?.session?.status || SESSION_STATUS.BOOTSTRAPPING;

export const selectIsAuthenticated = (state) =>
    selectSessionStatus(state) === SESSION_STATUS.AUTHENTICATED;

export const selectCurrentUser = (state) => state?.currentUser || {};
export const selectCurrentUserFunctions = (state) => {
    const functions = selectCurrentUser(state).functions;
    return Array.isArray(functions) ? functions : EMPTY_ARRAY;
};

export const selectCurrentUserFunctionsLoaded = (state) =>
    Boolean(selectCurrentUser(state).functionsLoaded);
export const selectCurrentUserPath = (state) =>
    selectCurrentUser(state).pathApp || '';
export const selectCurrentUserId = (state) =>
    selectCurrentUser(state).userId ?? null;
export const selectCurrentUsername = (state) =>
    selectCurrentUser(state).username || '';
export const selectCurrentUserLanguage = (state) =>
    selectCurrentUser(state).language || '';

export const selectDialogVisible = (state) => Boolean(state?.dialog?.open);

export const selectSystemConfigs = (state) => state?.common?.systemConfigs || null;
